import triggerTracking from '@blueprint/tracking';

export const articleTracking = (
    articleSlug: string,
    articleCategory: string,
    index: number
) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'discover',
        eventAction: 'clickthrough',
        eventLabel: `article,${
            index + 1
        },/discover/${articleCategory}/${articleSlug}/`
    });
};
